import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=8bd37ea8"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"
import style0 from "./panel.vue?vue&type=style&index=0&id=8bd37ea8&prod&lang=scss&scroped=true"
import style1 from "./panel.vue?vue&type=style&index=1&id=8bd37ea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports